<template>
  <div
    :class="[
      'mobile-navbar offcanvas offcanvas-end border-0',
      { show: stateStoreInstance.navbar },
    ]"
  >
    <div class="offcanvas-header">
      <RouterLink to="/" class="logo d-inline-block" @click="closeNav">
        <img :src="nav.logo_url || defaultLogo" alt="logo" style="max-height: 42px" />
      </RouterLink>

      <button
        type="button"
        class="close-btn bg-transparent position-relative lh-1 p-0 border-0"
        @click="closeNav"
      >
        <i class="ri-close-fill"></i>
      </button>
    </div>

    <div class="offcanvas-body">
      <ul class="mobile-menu">
        <!-- Same CMS-driven links as the desktop navbar -->
        <li
          v-for="link in visibleLinks"
          :key="link.url"
          class="mobile-menu-list without-icon"
        >
          <RouterLink :to="link.url" class="nav-link" @click="closeNav">
            {{ link.label }}
          </RouterLink>
        </li>

        <!-- Account -->
        <template v-if="authStore.isLoggedIn">
          <li class="mobile-menu-list without-icon">
            <RouterLink to="/dashboard" class="nav-link" @click="closeNav">
              <i class="ti ti-user"></i> My Dashboard
            </RouterLink>
          </li>
          <li v-if="authStore.isAdmin" class="mobile-menu-list without-icon">
            <RouterLink to="/admin" class="nav-link" @click="closeNav">
              <i class="ti ti-settings"></i> Admin Panel
            </RouterLink>
          </li>
          <li class="mobile-menu-list without-icon">
            <a href="#" class="nav-link" @click.prevent="handleLogout">
              <i class="ti ti-logout"></i> Logout
            </a>
          </li>
        </template>
        <template v-else>
          <li class="mobile-menu-list without-icon">
            <RouterLink to="/login" class="nav-link" @click="closeNav">
              <i class="ti ti-user"></i> Login
            </RouterLink>
          </li>
          <li class="mobile-menu-list without-icon">
            <RouterLink :to="nav.cta_url || '/register'" class="nav-link" @click="closeNav">
              {{ nav.cta_text || 'Get Started' }}
            </RouterLink>
          </li>
        </template>

        <li v-if="nav.phone" class="mobile-menu-list without-icon">
          <a :href="'tel:' + nav.phone" class="nav-link">
            <i class="ti ti-phone-incoming"></i> {{ nav.phone }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";
import stateStore from "@/utils/store";
import { useAuthStore } from "@/store/auth";
import { useContent } from "@/composables/useContent";

const defaultNavDefaults = {
  logo_url: "",
  phone: "",
  cta_text: "Get Started",
  cta_url: "/register",
  links: [
    { label: "Home",           url: "/",                visible: true },
    { label: "World Cup 2026", url: "/world-cup-2026",  visible: true },
    { label: "Blog",           url: "/blog",            visible: true },
    { label: "Pricing",        url: "/pricing",         visible: true },
    { label: "Channel List",   url: "/channels",        visible: true },
    { label: "FAQ",            url: "/faq",             visible: true },
    { label: "About Us",       url: "/about-us",        visible: true },
    { label: "Contact",        url: "/contact-us",      visible: true },
  ],
};

export default defineComponent({
  name: "MobileNavbar",
  setup() {
    const stateStoreInstance = stateStore;
    const authStore = useAuthStore();
    const router = useRouter();

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const defaultLogo = require("@/assets/images/logo.svg");

    const { content: nav } = useContent("navigation", defaultNavDefaults);

    const visibleLinks = computed(() =>
      (nav.value.links ?? []).filter((l: any) => l.visible !== false)
    );

    function closeNav() {
      if (stateStoreInstance.navbar) stateStoreInstance.responsiveNavbar();
    }

    async function handleLogout() {
      closeNav();
      await authStore.logout();
      router.push("/login");
    }

    return {
      stateStoreInstance, authStore,
      nav, visibleLinks, defaultLogo,
      closeNav, handleLogout,
    };
  },
});
</script>
